// CSS Dependencies: Bootstrap & Bootstrap icons
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/css/bootstrap.css';

// Custom CSS imports
import '../scss/site.scss';

// JS Dependencies: Popper & Bootstrap
import '@popperjs/core';
import * as bootstrap from 'bootstrap'
window.bootstrap = bootstrap;

console.log('The \'site\' bundle has been loaded!');